import Index from 'src/pages/ProductCategories/Index.vue'
import Create from 'src/pages/ProductCategories/Create.vue'
import Edit from 'src/pages/ProductCategories/Edit.vue'

const auth = { requiresAuth: true }
const notUser = { requiresNotUser: true }

export default [
  {
    path: '/product_categories',
    name: 'Produktkategorien',
    component: Index,
    meta: { ...auth, ...notUser }
  },
  {
    path: '/product_categories/create',
    name: 'Produktkategorie Erstellen',
    component: Create,
    meta: { ...auth, ...notUser }
  },
  {
    path: '/product_categories/:id/edit',
    name: 'Produktkategorie Bearbeiten',
    component: Edit,
    meta: { ...auth, ...notUser }
  }
]
